/* istanbul ignore file */
import styled from 'styled-components'
import { themeColor } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (min-width: ${props.theme.screens.large})`

export const RentalCarContractProcessMainContainer = styled.div`
    height: 100%;
    width: 100%;
    position: relative;

    display: flex;
    flex-direction: column;
    background: ${themeColor('white')};

    ${mediaScreenMobile} {
        height: 100%;
        padding-bottom: 32px;
    }
`

export const RentalCarContractProcessMainLockContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height:100%;
    background-color: #FFF;
    opacity: 0.4;
    z-index: 9;
`

export const RentalCarContractProcessWrapper = styled.div`
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
`

export const RentalCarContractMobileProcessWrapper = styled(RentalCarContractProcessWrapper)`
    margin: 4em 0 0 0;
`
